import { I18n } from '@calendly/i18n';
import { BareItem } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { useContext, forwardRef } from 'react';
import { SearchSelectContext } from 'components/core/search_select/context';
import { MenuItemInfo } from './menu_item_info';
const columnCss = "cmix0ez";
const Column = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(columnCss, props.className)} />;
});
const leftCss = "lm03off";
const Left = forwardRef((props, ref) => <Column ref={ref} {...props} className={classNames(leftCss, props.className)} />);
const rightSpanCss = "r1kz9oi6";
const RightSpan = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(rightSpanCss, props.className)} />;
});
const disabledReasonNoticeCss = "dscvepf";
const DisabledReasonNotice = forwardRef((props, ref) => <RightSpan ref={ref} {...props} className={classNames(disabledReasonNoticeCss, props.className)} />);
export const MenuItem = ({
  suggestion,
  isSelected,
  getUnavailabilityReason,
  getSideEffectInfo,
  onSelect,
  showUserRole
}) => {
  const closeMenu = useContext(SearchSelectContext).close;
  const unavailabilityReason = getUnavailabilityReason(suggestion.type, suggestion.entity);
  const sideEffectInfo = getSideEffectInfo(suggestion.type, suggestion.entity);
  const isDisabled = isSelected || !!unavailabilityReason;
  const handleSelection = () => {
    closeMenu();
    onSelect(suggestion);
  };
  const disabledReasonOrSideEffectInfo = () => {
    if (isDisabled) {
      return <DisabledReasonNotice>
          {isSelected ? I18n.t('publisher.organization.memberships_picker.already_selected') : unavailabilityReason}
        </DisabledReasonNotice>;
    }
    if (!isDisabled && sideEffectInfo) {
      return <RightSpan>
          {sideEffectInfo}
        </RightSpan>;
    }
    return null;
  };
  return <BareItem disabled={isDisabled} onClick={handleSelection}>
      <Left>
        <MenuItemInfo suggestion={suggestion} showUserRole={showUserRole} />
      </Left>
      <Column>
        {disabledReasonOrSideEffectInfo()}
      </Column>
    </BareItem>;
};

require("./menu_item.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./menu_item.js");